/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
 */
export interface ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
     */
    pages?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
     */
    subtype?: string;
}

/**
 * Check if a given object implements the ScreenerDocumentErrorMetadataRelatedDocumentInformationInner interface.
 */
export function instanceOfScreenerDocumentErrorMetadataRelatedDocumentInformationInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON(json: any): ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    return ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
        'subtype': !exists(json, 'subtype') ? undefined : json['subtype'],
    };
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON(value?: ScreenerDocumentErrorMetadataRelatedDocumentInformationInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'size': value.size,
        'pages': value.pages,
        'subtype': value.subtype,
    };
}

